<div class="header">
    <div class="logo-fijo-mobile">
        <img src="./assets/img/logo-metrogas.png" alt="Metrogas" />
    </div>
    <div class="btn-menu" (click)="openMenu()">
        <img src="./assets/img/menu.png" alt="Menú" />
    </div>
    <div class="menu-mobile">
        <div class="btn-cerrar" (click)="closeMenu()">
            <img src="./assets/img/close.png" alt="Cerrar menú" />
        </div>
        <div class="logo">
            <img src="./assets/img/logo-metrogas.png" alt="Metrogas" />
        </div>
        <div class="wrapper">
            <ul>
                <li>
                    <input type="button" value="Inicio" class="btn-header-2" (click)="irHome()">
                </li>
                <li>
                    <input type="button" value="Hogar Metrogas" class="btn-header-2" (click)="irMetrogas()">
                </li>
                <li>
                    <input type="button" value="Sucursal Virutal" class="btn-area-clientes-2 mi-cuenta-online" (click)="irSucursalVirtual()">
                </li>
            </ul>
        </div>
    </div>

    <div class="menu-desktop">
        <div class="btn-cerrar" (click)="closeMenu()">
            <img src="./assets/img/close.png" alt="Cerrar menú" />
        </div>

        <div class="wrapper">
            <div class="left">
                <div class="logo">
                    <img src="./assets/img/logo-metrogas.png" alt="Metrogas" />
                </div>
                <ul>
                    <li>
                        <input type="button" value="Inicio" class="btn-header-2" (click)="irHome()">
                    </li>
                    <li>
                        <input type="button" value="Hogar Metrogas" class="btn-header-2" (click)="irMetrogas()">
                    </li>
                    <!--
                    <li>
                      <input type="button" value="Grandes clientes" class="btn-header-2">
                    </li>
                    -->
                </ul>
            </div>

            <div class="right">
                <ul>
                    <!--
                    <li>
                      <input type="button" value="Nuestra empresa" class="btn-header-2">
                    </li>
                    <li>
                      <input type="button" value="Área Clientes" class="btn-area-clientes-2">
                    </li>
                    <li>
                      <input type="button" value="Pago fácil" class="btn-pago-facil-2">
                    </li>
                    -->
                    <li>
                        <input type="button" value="Sucursal Virutal" class="btn-area-clientes-2 mi-cuenta-online" (click)="irSucursalVirtual()">
                    </li>
                </ul>
            </div>
        </div>
    </div>